import React, { useState, useEffect, useCallback } from 'react';
import Sector from '../../../../../forms/sector';
import SectorExpenseType from '../../../../../forms/sectorExpenseType';
import restApiClient from '../../../../../services/restApiClient';
import CrudTable from '../../../../../components/crudTable';
import FilterTree from '../../../../../helpers/filterTree';
import { Container, TextGrammarSettings } from './styles';
import CreateUpdateGroupDialog from '../../../../../components/createUpdateGroupDialog';

function SectorView({ history }) {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderby] = useState({ name: 'asc' });
  const [searchBy, setSearchBy] = useState('');
  const [selectedId, setSelectedId] = useState(undefined);
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState({
    key: '',
    actionLabel: '',
    depthLabel: '',
  });

  const columns = Sector.listSchema;

  const loadSectors = useCallback(() => {
    restApiClient.sector
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy ? new FilterTree().like('name', searchBy).toString() : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    loadSectors();
  }, [loadSectors]);

  return (
    <Container>
      <CrudTable
        title={'Cadastro de Setores'}
        modelActions={Sector.actions}
        columns={columns}
        rows={rows}
        page={page}
        setPage={(page) => setPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
        onOrderByChange={(orderBy) => setOrderby(orderBy)}
        orderBy={orderBy}
        setOrderBy={(value) => setOrderby(value)}
        searchBy={searchBy}
        setSearchBy={(value) => setSearchBy(value)}
        actions={{
          add: {
            onClick: () => {
              setOpen(true);
              setAction({
                key: 'add',
                actionLabel: 'Cadastro',
                depthLabel: 'Setor',
              });
            },
          },
          update: {
            onClick: (paymentTypeId) => {
              setSelectedId(paymentTypeId);
              setOpen(true);
              setAction({
                key: 'edit',
                actionLabel: 'Edição',
                depthLabel: 'Setor',
              });
            },
            allowedActions: [[Sector.actions.findById, Sector.actions.update]],
          },
          config: {
            icon: <TextGrammarSettings />,
            onClick: (sectorId) => {
              history.push(`/employee/config/sector/${sectorId}/expense-types`);
            },
            title: 'Configurar Tipos de Despesas',
            allowedActions: [[SectorExpenseType.actions.getAllBySectorId]],
          },
          delete: {
            onClick: (paymentTypeId, index) => {
              restApiClient.sector.delete(paymentTypeId).then(() => {
                const result = { ...rows };
                if (index > -1) {
                  result.values.splice(index, 1);
                  result.count--;
                }
                setRows(result);
              });
            },
            selector: (row) => row?.employeesCount === 0,
          },
        }}
        customCellRenderers={{
          expenseType: {
            renderer: (field, value) => {
              if (value?.parent?.parent?.parent) {
                return `${value.parent.parent.parent.name} > ${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
              } else if (value?.parent?.parent) {
                return `${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
              } else if (value?.parent) {
                return `${value.parent.name} > ${value.name}`;
              } else {
                return value.name;
              }
            },
          },
        }}
      />
      <CreateUpdateGroupDialog
        open={open}
        restModel={restApiClient.sector}
        action={action}
        parentId={selectedId}
        onCancel={() => {
          setOpen(false);
          setSelectedId(undefined);
        }}
        onSuccess={() => {
          loadSectors();
          setOpen(false);
        }}
      />
    </Container>
  );
}

export default SectorView;
